/**
 * 피그마 인증 화면용 언더라인 인풋 (우측 보조 액션/타이머 포함)
 */
export default function UnderlineField({
  label,
  value,
  onChange,
  placeholder,
  maxLength,
  inputMode,
  autoComplete,
  disabled,
  rightSlot,
  error,
  readOnly,
  className = '',
  ...props
}) {
  return (
    <div className={`w-full ${className}`}>
      {label ? (
        <label className="mb-2.5 block font-['Pretendard'] text-[14px] leading-[1.32] text-gray04">
          {label}
        </label>
      ) : null}
      <div
        className={`relative flex h-[42px] items-center border-0 border-b border-solid px-3.5 ${
          error ? 'border-[#F6475F]' : 'border-primary-purple-01'
        }`}
      >
        <input
          type="text"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          inputMode={inputMode}
          autoComplete={autoComplete}
          disabled={disabled}
          readOnly={readOnly}
          className="min-w-0 flex-1 border-0 bg-transparent p-0 font-['Pretendard'] text-[16px] leading-[1.32] text-black outline-none placeholder:text-gray03 disabled:text-black"
          {...props}
        />
        {rightSlot ? (
          <div className="ml-2 shrink-0 font-['Pretendard'] text-[16px] leading-[1.32] text-primary-purple-01">
            {rightSlot}
          </div>
        ) : null}
      </div>
    </div>
  );
}
